import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => ({
	semaphore: {
		borderRadius: "100px",
		width: theme.spacing.unit,
		height: theme.spacing.unit,
		margin: theme.spacing.unit / 2,
	},
	semaphoreRed: {
		backgroundColor: "red",
	},
	semaphoreYellow: {
		backgroundColor: "orange",
	},
	semaphoreGreen: {
		backgroundColor: "green",
	}
}))(props => {
		let color
		switch (props.color) {
			case "green":
				color = props.classes.semaphoreGreen
				break
			case "yellow":
				color = props.classes.semaphoreYellow
				break
			default:
				color = props.classes.semaphoreRed
				break
		}
		return <div className = {`${props.classes.semaphore} ${color}`} ></div>
	}
)
